import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const BrandNameInput = ({ value, onChange }) => (
  <div className="bg-gray-50 border border-gray-200 rounded-xl px-4 py-3">
    <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5 flex items-center gap-1">
      <SafeIcon icon={FiIcons.FiTag} className="text-gray-400" /> Watermark Brand Name
    </label>
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Your brand name"
      className="w-full text-sm border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none bg-white"
      maxLength={40}
    />
    <p className="text-xs text-gray-400 mt-1">Appears as watermark on recorded video</p>
  </div>
);

export default BrandNameInput;